




















































































































































import { ExpenseItem } from "@/api/cost/expenses-api";
import SelectOption from "@/common/ui/presenters/select-option";
import { Component, Prop, Vue } from "vue-property-decorator";
import ExpenseRow from "./ExpenseRow.vue";

@Component({
  name: "ExpenseItemListItem",
  components: {
    ExpenseRow,
    ExpenseItemListItem
  }
})
export default class ExpenseItemListItem extends Vue {
  @Prop({ required: true }) item!: ExpenseItem;
  @Prop({ type: Number, default: 0 }) indent!: number;
  @Prop({ type: Boolean }) expanded!: boolean;

  get indentStyle() {
    return {
      width: `${this.indent * 1.5}rem`
    };
  }

  get expenseCategoryOptions(): SelectOption[] {
    return [
      {
        text: "",
        value: ""
      }
    ].concat(this.$store.getters.expenseCategoryOptions);
  }

  updateTotal() {
    this.item.unitPrice = this.item.unitPrice || 0;
    this.item.amount = this.item.amount || 0;
    this.item.total = this.item.unitPrice * this.item.amount;
    this.$emit("input", this.item);
  }
}
